import { faBookmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import moment from 'moment';
import { Col, Container, Row } from 'react-bootstrap';
import SetReturnStateLink from '../../../components/SetReturnStateLink';
import { buildParams } from '../notifications/NotificationHelper';
import { InlineMatchedFeature, InlineNotification } from './Inline.types';
import { impactLevelName } from './inlineImpact';

import '../notifications/css/notificationrow.css';
import './InlineRules.css';
import type { PageReturnDetails } from '../notifications/Notification.types';

/**
 * One row of the INLINE notifications list, laid out like the EFAS notification rows.
 * The river/basin and the alert level come from the notification's matched feature,
 * which the API delivers as a GeoJSON string.
 */
export default function InlineNotificationRow(props: {
    notification: InlineNotification,
    return_details: PageReturnDetails
}) {
    const notification = props.notification;
    const detail_url = `/inline/notifications/${notification.id}?${buildParams(props.return_details.page, props.return_details.search, props.return_details.date)}`;

    let feature: InlineMatchedFeature | null = null;
    try {
        feature = JSON.parse(notification.matched_feature) as InlineMatchedFeature;
    } catch (error) {
        console.warn("Failed to parse matched_feature", error);
    }

    const river = feature?.properties?.riverName;
    const basin = feature?.properties?.basinName;
    const level = impactLevelName(feature?.properties?.impact_p90 as number | undefined);

    return (
        <tr data-testid={`inline-notification-${notification.id}`}>
            <td>
                <Row className='efas-notification-row'>
                    <Col className='col-xl-1 col-lg-1 col-md-2 col-1 mx-auto my-auto efas-notification-row-bookmark'>
                        <FontAwesomeIcon icon={faBookmark} />
                    </Col>
                    <SetReturnStateLink to={detail_url} className='efas-notification-row-anchor col-xl-9 col-lg-10 col-md-9 col-9'>
                        <Container className='efas-notification-row-container'>
                            <Row className='efas-notification-row-title'>
                                Issued on {moment.utc(notification.issue_date).format("YYYY-MM-DD HH:mm")}
                                {" - "}forecast {moment.utc(notification.forecast_date).format("YYYY-MM-DD HH:mm")}
                                {" - "}leadtime {moment.utc(notification.leadtime).format("YYYY-MM-DD HH:mm")}
                            </Row>
                            <Row className='efas-notification-row-body'>
                                <div className='d-flex flex-row justify-content-between p-0'>
                                    <div>
                                        {notification.group || "No group"}
                                        {river ? ` - River: ${river}` : ""}
                                        {basin ? ` - Basin: ${basin}` : ""}
                                        {notification.rule_name ? ` - Rule: ${notification.rule_name}` : ""}
                                    </div>
                                    <div className='d-flex flex-row align-end'>
                                        {level ?
                                            <span className={`rounded px-2 mx-1 edera-label-${level.toLowerCase()}`}>{level}</span>
                                            : null}
                                        {notification.historical ? <span className='px-2'>Historical</span> : null}
                                        <span className='px-2'>{notification.close_time ? "Closed" : "Ongoing"}</span>
                                    </div>
                                </div>
                            </Row>
                        </Container>
                    </SetReturnStateLink>
                </Row>
            </td>
        </tr>
    );
}
